import { render, staticRenderFns } from "./OperaDepartmentWindow.vue?vue&type=template&id=7c66720c&"
import script from "./OperaDepartmentWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDepartmentWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports